<webmodule-order-panel>
  <ng-container heading>
    <h3 class="mb-0">{{ 'block.base.duration.heading' | translate }}</h3>
  </ng-container>
  <ng-container content>
    <h4>{{  'block.base.duration.label' | translate }}</h4>
    <p>{{ 'block.base.duration.description' | translate }}</p>

    <fieldset [disabled]="true">
      <legend class="sr-only">{{  'block.base.duration.label' | translate }}</legend>
      <div class="grid grid-cols-2 gap-4">
        <button class="button primary outline active">{{ 'block.base.button.twelve-month' | translate }}</button>
        <button class="button primary outline disabled">{{ 'block.base.button.twenty-four-month' | translate }}</button>
      </div>
    </fieldset>

  </ng-container>
</webmodule-order-panel>
